import React, { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

const StyledSelect = styled.select`
  width: 100%;
  padding: 8px;
  border-radius: 10px;
  font-size: 16px;
  border: 1px solid lightgray;

  &:focus-visible {
    outline: none;
    border-color: #1e90ff;
    box-shadow: 0 0 0 2px rgba(30, 144, 255, 0.3);
  }
`;

const DropdownWrapper = (props) => {
    const { lang } = useSelector((state) => state.languageSelectorReducer);
    const { loading, bankMenu, value, onChange, ...rest } = props;

    if (loading) {
        return <div style={{ textAlign: "center", padding: "10px" }}>Loading...</div>;
    }

    return (
        <StyledSelect
            value={value}
            onChange={(e) => {
                onChange(e.target.value);
            }}
            disabled={loading}
            {...rest}
        >
            <option value="">Select a bank</option>
            {bankMenu?.map((item) => {
                const isAvailable = item?.hasOwnProperty("isAvailable") ? item.isAvailable : true;
                const displayName = item.bankNameEng;

                return (
                    <option
                        key={item.id}
                        value={item.bankNameEng}
                        disabled={!isAvailable}
                        style={{ backgroundColor: !isAvailable ? "#f5f5f5" : "transparent" }}
                    >
                        {displayName}
                    </option>
                );
            })}
        </StyledSelect>
    );
};

export default DropdownWrapper;
